// Why "unsafe"? See `getSafeWindowHeight`
export default function getUnsafeWindowHeight() {
  return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
}
